import { render, staticRenderFns } from "./AppointmentHistory.vue?vue&type=template&id=036d1ba4&"
import script from "./AppointmentHistory.vue?vue&type=script&lang=js&"
export * from "./AppointmentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports